/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:18
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-16 14:42:03
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\base\actions.js
 */
const actions = {
}
export default actions